import React, { useEffect, useRef, useState } from "react";
import "./NewTradingHistory.scss";
import ReactTable from "../ReactTable/ReactTable";
import { ReactComponent as UncheckedCheckbox } from "../../assets/icons/NewIcons/uncheckedCheckbox.svg";
import { ReactComponent as CheckedCheckbox } from "../../assets/icons/NewIcons/checkedCheckboxWhite.svg";
import { ReactComponent as AddIcon } from "../../assets/icons/NewIcons/AddIconWhite.svg";
import dayjs from "dayjs";
import CreateTrader from "../Trademate/CreateTrader";
import CombinedPopup from "../Popups/CombinedPopup";
import { fetchTraderJournalCreate } from "../../store/reducers/trademateReducer";
import { useDispatch } from "react-redux";
import TradingViewChart from "./NewCalender/TradingGraph/TradingViewChart";
import { FormatUSD } from "../../utilities/string";

const NewTradingHistory = ({ TradingHistory, add = true }) => {
  const formatDate = (dateString) => {
    return dayjs(dateString).format("DD MMM YYYY");
  };

  const formatTime = (dateString) => {
    return dayjs(dateString).format("HH:mm:ss");
  };

  const sortedTradingHistory =
    TradingHistory &&
    TradingHistory?.slice().sort((a, b) => {
      return new Date(b.date).getTime() - new Date(a.date).getTime();
    });

  console.log("TradingHistory", sortedTradingHistory);

  // POPUP States
  const [Show, setShow] = useState(false);
  const [CombinedPUHead, setCombinedPUHead] = useState("");
  const [SPopup, setSPopup] = useState(false);
  const [CombinedPUBody, setCombinedPUBody] = useState("");
  const [PopUpType, setPopUpType] = useState("");

  const dispatch = useDispatch();

  const handleFormSubmit = (Data) => {
    console.log(Data, "data");
    dispatch(fetchTraderJournalCreate(Data))
      .then((res) => {
        if (res) {
          // SUCCESS
          setSPopup(true);
          setCombinedPUHead("Success");
          setCombinedPUBody("Journal created!");
          setPopUpType("success");
        } else {
          setSPopup(true);
          setCombinedPUHead("Error");
          setCombinedPUBody("Something went wrong");
          setPopUpType("error");
        }
      })
      .catch((error) => {
        alert("Error");
      });
  };
  const [tradingData, setTradingData] = useState(null);
  const columns = [
    {
      Header: "Deal ID",
      accessor: "deal",
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "Open Time",
      accessor: "date",
      Cell: ({ row, value }) => (
        <div className="dateBox" onClick={() => setTradingData(row.originalF)}>
          <p>{value ? formatDate(value) : "N/A"}</p>
          <p>{value ? formatTime(value) : "N/A"}</p>
        </div>
      ),
    },
    {
      Header: "Symbol",
      accessor: "symbol",
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "Action",
      accessor: "action", // Buy or Sell
      Cell: ({ value }) => (
        <div
          className={`${
            value === "Buy"
              ? "profitValue"
              : value === "Sell"
              ? "lossValue"
              : ""
          }`}
        >
          {value ?? "N/A"}
        </div>
      ),
    },
    {
      Header: "Lots",
      accessor: "volume", // Number of lots
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "Open Price",
      accessor: "price", // Price at which the trade was opened
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "Profit",
      accessor: "profit", // Profit/loss from the trade
      Cell: ({ value }) => (
        <div
          className={`${
            value > 0 ? "profitValue" : value < 0 ? "lossValue" : ""
          }`}
        >
          {FormatUSD(value) ?? "0"}
        </div>
      ),
    },
    {
      Header: "Profit Rate",
      accessor: "profitRate", // Profit rate percentage
      Cell: ({ value }) => (
        <div>{value != null ? value.toFixed(2) : "N/A"}</div>
      ), // Check for null or undefined
    },
    {
      Header: "Commission",
      accessor: "commission", // Commission on the trade
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "Swap",
      accessor: "swap", // Swap fees
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "Reason",
      accessor: "reason", // Reason for the trade
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "Entry",
      accessor: "entry", // Entry status (e.g., "In")
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "SL",
      accessor: "stopLoss", // Stop-loss value
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "TP",
      accessor: "takeProfit", // Take-profit value
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "Order",
      accessor: "order", // Order ID
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "Position",
      accessor: "position", // Position ID
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
    {
      Header: "Volume Closed",
      accessor: "volumeClosed", // Volume closed
      Cell: ({ value }) => <div>{value ?? "N/A"}</div>, // Check for null or undefined
    },
  ];

  const filters = ["Profit", "Buy", "Sell"];

  const [createTradeVisibility, setCreateTradeVisibility] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [filterVisibility, setFilterVisibility] = useState(false);
  const filterRef = useRef(null);
  const buttonRef = useRef(null);
  const traderRef = useRef(null);
  const tradeButtonRef = useRef(null);
  const [filteredData, setFilteredData] = useState(TradingHistory);

  const handleFilterToggle = (filter) => {
    setSelectedFilters((prevFilters) => {
      const newFilters = { ...prevFilters };
      newFilters[filter] = !newFilters[filter];
      return newFilters;
    });
  };

  // Close filter dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        filterRef.current &&
        !filterRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setFilterVisibility(false);
      }
    };

    // Add event listener for clicks
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const applyFilters = () => {
    let data = TradingHistory;

    // If "Profit" and "Buy" are selected, show only Buy trades with profit > 0
    if (selectedFilters["Profit"] && selectedFilters["Buy"]) {
      data = data.filter((trade) => trade.action === "Buy" && trade.profit > 0);
    } else if (selectedFilters["Buy"] && selectedFilters["Sell"]) {
      data = TradingHistory.filter(
        (trade) => trade.action === "Buy" || trade.action === "Sell"
      );
    }
    // If "Profit" and "Sell" are selected, show only Sell trades with profit > 0
    else if (selectedFilters["Profit"] && selectedFilters["Sell"]) {
      data = data.filter(
        (trade) => trade.action === "Sell" && trade.profit > 0
      );
    }

    // If "Profit", "Buy", and "Sell" are selected, show both Buy and Sell trades with profit > 0
    else if (
      selectedFilters["Profit"] &&
      selectedFilters["Buy"] &&
      selectedFilters["Sell"]
    ) {
      data = data.filter(
        (trade) =>
          (trade.action === "Buy" || trade.action === "Sell") &&
          trade.profit > 0
      );
    }

    // If only "Profit" is selected, show trades with profit > 0 (no action filter)
    else if (selectedFilters["Profit"]) {
      data = data.filter((trade) => trade.profit > 0);
    }

    // If "Buy" is selected, show only Buy trades (no profit filter)
    else if (selectedFilters["Buy"]) {
      data = data.filter((trade) => trade.action === "Buy");
    }

    // If "Sell" is selected, show only Sell trades (no profit filter)
    else if (selectedFilters["Sell"]) {
      data = data.filter((trade) => trade.action === "Sell");
    }

    setFilteredData(data);
  };

  useEffect(() => {
    applyFilters();
  }, [selectedFilters, TradingHistory]);

  const handleCross = () => {
    setCreateTradeVisibility(false);
  };

  useEffect(() => {
    if (createTradeVisibility) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [createTradeVisibility]);
  const priceData = [
    { time: "2024-10-10", value: 42400.0 },
    { time: "2024-10-11", value: 42500.0 },
    { time: "2024-10-12", value: 42583.75 },
  ];

  const tradeMarkers = [
    {
      time: "2024-10-10T13:37:50",
      position: "aboveBar",
      color: "red",
      shape: "arrowDown",
      text: "Sell @ 424689.55",
    },
    {
      time: "2024-10-11T16:32:15",
      position: "belowBar",
      color: "blue",
      shape: "arrowUp",
      text: "Close @ 42583.75",
    },
  ];

  const chartOptions = {
    backgroundColor: "#f8f9fa",
    textColor: "#333333",
    gridColor: "#e0e0e0",
    borderColor: "#cccccc",
    lineColor: "#4CAF50",
  };
  return (
    <>
      <div className="newTradeHistoryContainer">
        <div className="headerSection">
          <h3>Trading Activity</h3>

          <div className="filter_container">
            {add && (
              <button
                className="addButton"
                ref={tradeButtonRef}
                onClick={() => setCreateTradeVisibility((prev) => !prev)}
              >
                <AddIcon />
                Add Trade
              </button>
            )}
            <button
              ref={buttonRef}
              onClick={() => setFilterVisibility((prev) => !prev)}
            >
              Filters
            </button>

            <div
              ref={filterRef}
              className={`filterWrapper ${
                filterVisibility ? "filterVisible" : "filterHidden"
              }`}
            >
              {TradingHistory && TradingHistory.length > 0 ? (
                filters.map((filter) => (
                  <div
                    className={`filterItems ${
                      selectedFilters[filter] ? "checked" : ""
                    }`}
                    key={filter}
                    onClick={() => handleFilterToggle(filter)}
                    style={{ cursor: "pointer" }}
                  >
                    {selectedFilters[filter] ? (
                      <CheckedCheckbox />
                    ) : (
                      <UncheckedCheckbox />
                    )}
                    <span style={{ color: "#fff" }}>{filter}</span>
                  </div>
                ))
              ) : (
                <div style={{ textAlign: "center", color: "#fff" }}>
                  No Data to filter
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="newTradeHistoryWrapper">
          <ReactTable
            columns={columns || []}
            data={(filteredData || []).reverse()}
          />
          {/* <TradingViewChart
            priceData={priceData}
            tradeMarkers={tradeMarkers}
            chartOptions={chartOptions}
          /> */}
        </div>
      </div>
      <div
        className={`createTradeJournalContainer ${
          createTradeVisibility ? "traderVisible" : "traderHidden"
        }`}
      >
        <div className="createJournalWrapper" ref={traderRef}>
          <CreateTrader
            handleCross={handleCross}
            handleFormSubmit={handleFormSubmit}
          />
        </div>
        <CombinedPopup
          type={PopUpType}
          trigger={SPopup}
          setTrigger={setSPopup}
          head={CombinedPUHead}
          subhead={CombinedPUBody}
          setShow={setShow}
        />
      </div>
    </>
  );
};

export default NewTradingHistory;
